import HeroSlider from "./HeroSlider";
import FixedBackgroundPosition from "../FixedBackgroundPosition";
import HeroSliderWithLogo from "./HeroSliderWithLogo";

class VerticalAmericanDynamism {
    constructor() {
        this.init();
    }

    init() {
        this.initSliders();
        new FixedBackgroundPosition('.fixed-background-position');
    }

    initSliders() {
        const element = document.querySelector('.american-dynamism-hero-slider');
        if(element) {
            new HeroSliderWithLogo(element);
        }
    }
}

export default VerticalAmericanDynamism;
